import React from 'react'
import './styles.scss'

interface RoundedIconProps {
  icon?: string
}

const RoundedIcon = ({ icon = 'help' }: RoundedIconProps): JSX.Element => {
  return (
    <div className='ui-rounded-icon'>
      <span className={`mdi mdi-${icon}`} />
    </div>
  )
}

export default RoundedIcon
